import { Button, SettingsRow, SettingsSection } from '@wundo/ui';
import { AddExceptionDialog } from '@/components/meetings/AddExceptionDialog.tsx';
import type { MeetingFollowExceptionItem } from '@/lib/meetingFollow.ts';
import { m } from '@/paraglide/messages.js';

interface MeetingExceptionsSectionProps {
  /** What was switched off: no following, or no report. */
  exceptions: readonly MeetingFollowExceptionItem[];
  removing: boolean;
  onRemove: (exceptionId: string) => void;
}

/** The meetings and people Wundo leaves alone, against the kinds above. */
export function MeetingExceptionsSection({
  exceptions,
  removing,
  onRemove,
}: MeetingExceptionsSectionProps) {
  return (
    <SettingsSection
      title={m.meetings_exceptions_title()}
      description={m.meetings_exceptions_desc()}
      action={<AddExceptionDialog />}
    >
      {exceptions.length > 0 ? (
        exceptions.map((exception) => (
          <SettingsRow
            key={exception.id}
            label={exception.label ?? m.meetings_exception_unknown()}
            description={ruleOf(exception)}
          >
            <Button
              size='sm'
              variant='dangerQuiet'
              disabled={removing}
              onClick={() => onRemove(exception.id)}
            >
              {m.meetings_exception_remove()}
            </Button>
          </SettingsRow>
        ))
      ) : (
        <p className='px-5.5 py-4 text-sm text-ink-muted'>
          {m.meetings_exceptions_empty()}
        </p>
      )}
    </SettingsSection>
  );
}

/*
 * What was switched off, in the user's words. `follow` outranks `record`: a
 * meeting Wundo does not follow has no report to speak of either.
 */
function ruleOf(exception: MeetingFollowExceptionItem): string {
  if (exception.follow === false) return m.meetings_exception_no_follow();
  return m.meetings_exception_no_record();
}
